/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var listRequest = require('../list/list-request');
var rootScope = require('./root-scope.service');

module.exports = function () {
    if (rootScope.getListDetails() && rootScope.getTemplateName() === 'standalone') {
        rootScope.getListHandler()(null, rootScope.getListDetails());
    } else {
        listRequest();
    }
};
